import moment from "moment";

const RenderDateCustom = (value, bandera = 2) => {
  let renderDate;
  switch (bandera) {
    case 1:
      renderDate =
        value !== null && value !== undefined
          ? moment(value).format("DD/MM/YYYY HH:mm:ss")
          : null;
      break;
    case 2:
      renderDate =
        value !== null && value !== undefined
          ? moment(value).format("DD/MM/YYYY")
          : null;
      break;
    case 3:
      renderDate =
        value !== null && value !== undefined
          ? moment(value).format("YYYY")
          : null;
      break;
    default:
      break;
  }
  return renderDate;
};

export default RenderDateCustom;
